import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileType } from '../file-handler/file-link.component';
import { DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';
import { JoiFile } from 'globals/store/files.model';
import { FileHandlerComponent } from '../file-handler/file-handler.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'links-dialog',
    template: `

<dialog-wrapper
  [backgroundColor]="'#11b8c1'"
  [successLabel]="'DONE'"
  [disabled]="false"
  [dontResize]="true"
  [fitContent]="true"
  [dialogTitle]="data.dialogTitle"
  (submit)="done()"
>
  <div class="links-description" *ngIf="!!data.description">{{ data.description }}</div>
  <div class="links-title">{{ data.linksTitle }}</div>
  <file-handler 
    [data]="{ files: links }"
    [showNoFilesMessage]="!links.length"
    [type]="data.linkType"
    [namePlaceholder]="data.namePlaceholder"
    [noFilesMessage]="data.linksEmptyText"
    [addText]="data.addLinkText"
    [hideByline]="true"
  ></file-handler>
</dialog-wrapper>
  `,
    styleUrls: ['./links.dialog.scss'],
    standalone: true,
    imports: [FileHandlerComponent, DialogWrapperComponent, CommonModule],
})
export class LinksDialogComponent {

  links: JoiFile[] = []
  @ViewChild(DialogWrapperComponent) dialogWrapper : DialogWrapperComponent

  constructor(
    public dialogRef: MatDialogRef<LinksDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: LinksDialogData
  ) {
    this.links = data.links ? [...data.links] : []
  }

  done() {
    this.dialogRef.close(
      JSON.stringify(this.data.links) !== JSON.stringify(this.links) ? this.links : null
    )
  }

  resizeDialog() {
    this.dialogWrapper.fitChildrenWithDelay(100)
  }

}

export interface LinksDialogData {
  links: JoiFile[]
  dialogTitle: string
  description: string
  linksTitle: string
  linkType: FileType
  linksEmptyText: string
  addLinkText: string
  namePlaceholder: string
}